import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircle } from "react-feather";
import "./ServicesCard.css"; // Updated styles
import service1 from "../Assets/ServicePageImages/1_Front end Billing services.jpg";
import service2 from "../Assets/ServicePageImages/2_Medical Coding_Services page.jpg";
import service3 from "../Assets/ServicePageImages/3_Backend RCM Service.jpg";
import service4 from "../Assets/ServicePageImages/4_Provider Credentialing.jpg";

import service5 from "../Assets/ServicePageImages/5_Specialty focused end to end Medical Billing Services.png";
import service6 from "../Assets/ServicePageImages/6_Telemedicine Services.png";
import service7 from "../Assets/ServicePageImages/7_Analytics & Reporting.png";
import service8 from "../Assets/ServicePageImages/8_Technology & Software support.png";

const ServicesCard = () => {
  const servicesData = [
    {
      image: service1,
      title: "Front end Billing services",
      points: [
        "Patient registration, Appointment scheduling and demography creation",
        "Insurance verification and eligibility checks",
        "Charge entry, Charge reconciliation and claim generation",
        "Claim submission (electronic & paper) - Claim scrubbing, Claim Rejection & Edit resolution",
        "Prior authorization management (Pre visit)",
      ],
    },
    {
      image: service2,
      title: "Coding & Compliance",
      points: [
        "Medical coding (CPT, ICD-10, HCPCS)",
        "Certified coding audits (by CPC, CCS, etc.)",
        "Upcoding and downcoding prevention",
        "Compliance with HIPAA, CMS, and OIG guidelines",
        "Documentation review and improvement",
        "Risk adjustment coding (HCC, RAF scoring)",
        "MACRA, MIPS, and value-based care reporting",
      ],
    },
    {
      image: service3,

      title: "Backend RCM services",
      points: [
        "Payment posting (ERA & manual posting)",
        "Cash Reconciliation",
        "Credit Balance and Refunds",
        "Correspondence and Adjustments",
        "Assistance with balance billing",
        "Accounts receivable (A/R) follow-up",
        "Prior authorization follow ups",
        "Denial management and appeals",
        "Patient billing and statements",
        "Collections management",
        "Appeal for underpaid claims",
        "Worker's compensation & Personal injury claims",
        "Support in backlog clearance & emergency support during staffing shortage",
      ],
    },
    {
      image: service4,

      title: "Credentialing & Provider Enrollment",
      points: [
        "Provider enrollment with payers (Medicare, Medicaid, Commercial payers)",
        "Recredentialing and provider updates",
        "Indexing provider credential documents",
      ],
    },

    {
      image: service5,

      title: "Specialty focused end to end Medical Billing Services",
      points: [
        "Billing for specific medical specialties (e.g., radiology, cardiology, mental health, urgent care)",
        "Durable Medical Equipment (DME) billing",
        "Laboratory and pathology billing",
        "Ambulatory surgical center (ASC) billing",
      ],
    },
    {
      image: service6,

      title: "Telemedicine Billing Services",
      points: [
        "Coding and billing for virtual visits",
        "Compliance with telehealth regulations",
        "Reimbursement optimization for telehealth services",
      ],
    },
    {
      image: service7,

      title: "Analytics & Reporting",
      points: [
        "Customized financial reports",
        "KPI tracking and benchmarking",
        "Denial analysis and reduction strategies",
        "Revenue cycle performance monitoring",
      ],
    },
    {
      image: service8,

      title: "Technology & Software Support",
      points: [
        "Medical billing software integration (e.g., with EHR/EMR)",
        "Cloud-based billing solutions",
        "Tailored applications like RCM Scorecard handy for the Clevel team.",
        " ToDoRCM for daily task management between onshore and offshore business associates.",
        "A lot further through our strategic partner RCMSUMMIT.COM",
      ],
    },
  ];
  return (
    <Container fluid className="services-container">
      <Row className="text-center services-header">
        <p className="services-subtitle mt-5">Services Spectrum</p>
      </Row>

      {servicesData.map((service, index) => (
        <div className="container mt-5" key={index}>
          <Row
            className={`services-content ${
              index % 2 === 0 ? "reverse" : ""
            } mb-5`}
          >
            <Col
              lg={6}
              className="services-image-container"
              style={{ marginTop: "20px" }}
            >
              <img
                src={service.image}
                alt={service.title}
                className="services-image"
              />
            </Col>
            <Col lg={6} className="services-text">
              <h3 className="services-heading">{service.title}</h3>
              <p className="services-description">{service.description}</p>
              <div className="services-list">
                {service.points.map((point, i) => (
                  <p key={i}>
                    <i className="fa fa-check-circle services-icon" />
                    {point}
                  </p>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      ))}
    </Container>
  );
};

export default ServicesCard;
